var openInfoWindow = null;
var markers = [];

var initializeBlockMap = function(block){
	
	var mapElement = jQuery("#map");
	
	if(!mapElement.length) {
		return false;
	}
	
	var lat = parseFloat(mapData.lat);
	var lng = parseFloat(mapData.lng);
	var zoom = parseFloat(mapData.zoom);
	var markerData = JSON.parse(mapData.markers);
		
	var map = new google.maps.Map(mapElement[0], {
		center				: {lat: lat, lng: lng},
		zoom				: zoom,
		mapTypeControl		: false,
		scaleControl		: false,
		streetViewControl	: false,
		rotateControl		: false,
		fullscreenControl	: false,
		mapId				: mapData.mapID,
		styles  			: mapData.jsonStyling
	});

	for(var i=0; i<markerData.length; i++) {
		createMarker(markerData[i], map, markers);
	}

	if(mapData.showAll) {
		centerMap(markers, map);
	}
	
	if(jQuery(".accordion", block).length) {
		jQuery(".accordion .content li", block).on("click", function(){
			
			var current = jQuery(this);
			var index = current.attr("data-marker");
			
			triggerMarkerClick(index);
			
		});
	}
	
}


//initialize each block on front end
jQuery(document).ready(function(){
	jQuery('.wp-block-map').each(function(){
		initializeBlockMap(jQuery(this));
	});
});

//initialize dynamic block preview in the editor
if(window.acf)
	window.acf.addAction('render_block_preview/type=map', initializeBlockMap);


function createMarker(markerData, map, markers) {
	
	if(mapData.marker) {
	
		var markerWidth = mapData.markerWidth;
		var markerHeight = mapData.markerHeight;
		var markerDefault = mapData.marker;
		//var markerHover = "/wp-content/themes/plumbweb-child/_assets/img/marker-hover.svg";
		
		var marker = new google.maps.Marker({
			map			: map,
			position	: {lat: markerData.lat, lng: markerData.lng},
			icon 		: { 
				url			: markerDefault, 
				size		: new google.maps.Size(markerWidth, markerHeight), 
				scaledSize	: new google.maps.Size(markerWidth, markerHeight)
			}
		});
		
		//marker.addListener('mouseover', function(){
			//marker.setIcon(markerHover);
		//});
		
		//marker.addListener('mouseout', function(){
			//marker.setIcon(markerDefault);
		//});
		
	} else {
	
		var marker = new google.maps.Marker({
			map			: map,
			position	: {lat: markerData.lat, lng: markerData.lng}
		});
		
		var markerHeight = 35;
		
	}
	
	marker.set("html", markerData.html);
	
	marker.addListener('click', function(){
		
		if(openInfoWindow) {
			openInfoWindow.close();
		}
		
		var infowindow = new google.maps.InfoWindow({
			content: marker.get("html"),
			position: {lat: marker.getPosition().lat(), lng: marker.getPosition().lng()},
			pixelOffset: new google.maps.Size(0, -markerHeight - 10)
		});
		
		map.panTo(marker.getPosition());
		
		infowindow.open(map);
		
		openInfoWindow = infowindow;
		
	});
	
	markers.push(marker);
	
}

function centerMap(markers, map){
	
	if(markers.length){
	
		var bounds = new google.maps.LatLngBounds();
		
		for(var i=0; i<markers.length; i++){
			
			bounds.extend({
				lat: markers[i].position.lat(),
				lng: markers[i].position.lng()
			});
			
		}
	
		if(markers.length == 1){
			map.setCenter(bounds.getCenter());
	
		} else{
			map.fitBounds(bounds);
		}
	
	}
	
}

function triggerMarkerClick(index) {
	if(markers[index]) {
		google.maps.event.trigger(markers[index], "click");
	}
}
